<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start" *ngIf="currentModule">
    <div *ngIf="currentModule && isDataFetched; else shimmer">
        <!-- CONTENT CARD -->
        <div class="content-card mat-elevation-z2 mb-32">
            <mat-toolbar-row *ngIf="currentModule.sectionRule !== 'default'" class="form-toolbar parent" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="toolbar-title">
                        <span>{{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.TITLE' | translate }}</span>
                    </span>

                    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.MANAGE'" (onClick)="openManageCompletionDialog()"></app-white-button>
                </div>
            </mat-toolbar-row>

            <!-- CONTENT -->
            <div
                class="content p-24 white"
                fxLayout="column"
                *ngIf="
                    currentModule.sectionRule === SectionRule.TrackProgress || currentModule.sectionRule === SectionRule.Sequential || currentModule.type === ModuleType.ELearning
                "
            >
                <div fxLayout="row" *ngIf="moduleUser?.moduleUserProgress">
                    <section class="analytics-container rounded bg-zinc-50 p-16 mb-16 mr-24" *ngIf="moduleUser?.moduleUserProgress && currentModule.type !== ModuleType.ELearning">
                        <span class="analytics-title mb-16">{{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.SECTION_COMPLETED' | translate }}</span>
                        <mat-progress-bar
                            attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                            class="mb-8"
                            mode="determinate"
                            [value]="(moduleUser.moduleUserProgress?.completedSectionsCount * 100) / currentModule.sectionCount"
                        >
                        </mat-progress-bar>
                        <span class="sections-completed-progress">{{ moduleUser.moduleUserProgress?.completedSectionsCount || 0 }} / {{ currentModule.sectionCount }}</span>
                    </section>

                    <section class="analytics-container rounded bg-zinc-50 p-16 mb-16 mr-24">
                        <span class="analytics-title mb-8"> {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.TIME_SPENT' | translate }}</span>
                        <span class="analytics-value">{{ moduleUser.analytics.timeSpent | formatTimeSpent }} </span>
                    </section>

                    <section class="analytics-container rounded bg-zinc-50 p-16 mb-16 mr-24">
                        <span class="analytics-title mb-8"> {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.TIMES_VISITED' | translate }}</span>
                        <span class="analytics-value">{{ moduleUser.analytics.visitedCount }}</span>
                    </section>
                </div>

                <mat-table
                    *ngIf="currentModule.type !== 'e_learning' && dataSource?.length"
                    class="mat-elevation-z0"
                    #table
                    [dataSource]="dataSource"
                    matSort
                >
                    <!-- Section Column -->
                    <ng-container matColumnDef="section">
                        <mat-header-cell class="pl-24" *matHeaderCellDef mat-sort-header>
                            {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.SECTIONS' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let userSection">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <p class="text-truncate m-0">
                                    {{ userSection.section.name }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- Time Spent in Module Column -->
                    <ng-container matColumnDef="timeSpent">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.TIME_SPENT_IN_SECTION' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let userSection" fxHide fxShow.gt-xs>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <p class="text-truncate m-0">
                                    {{ userSection.section.timeSpent | formatTimeSpent: true }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- Time Spent Column -->
                    <ng-container matColumnDef="visitedCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.VISITS_TO_SECTION' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let userSection" fxHide fxShow.gt-xs>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <p class="text-truncate m-0">
                                    {{ userSection.section.visitedCount }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- Completion Column -->
                    <ng-container matColumnDef="completion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.COMPLETION' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let userSection">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <p class="text-truncate m-0">
                                    {{
                                        (userSection.completed
                                            ? 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED'
                                            : 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_COMPLETED'
                                        ) | translate
                                    }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let certificate; columns: displayedColumns" class="certificate" matRipple> </mat-row>
                </mat-table>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->

        <div fxLayout="row wrap" fxLayoutAlign="space-between" class="user-data-container">
            <!-- Grades -->
            <div class="content-card mat-elevation-z2 white user-data" *ngIf="isGradebookFeatureEnabled && currentModule.type !== 'e_learning'">
                <mat-toolbar-row class="form-toolbar parent" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="toolbar-title">
                            <span>{{ 'GRADING_SCHEME.LABEL.GRADES' | translate }}</span>
                        </span>
                    </div>

                    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.MANAGE'" (onClick)="manageGrades()"></app-white-button>
                </mat-toolbar-row>

                <!-- CONTENT -->
                <div class="content p-24" fxLayout="column">
                    <h3 class="mt-0" *ngIf="partialGrades?.length || finalGrades?.length">
                        <b>{{ 'GRADED_UNIT.PLURAL' | translate }}</b>
                    </h3>
                    <mat-list class="pb-24 pt-0">
                        <div *ngIf="finalGrades?.length">
                            <mat-list-item class="subject-container mb-12" *ngFor="let finalGrade of finalGrades">
                                <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="column" fxLayoutAlign="start">
                                        <span class="subject-title">{{ 'FINAL_GRADE.LABEL.GRADE' | translate }}</span>
                                        <span class="subject-description">{{ finalGrade.grade ? finalGrade.grade.displayValue : '-' }} </span>
                                    </div>
                                    <div
                                        *ngIf="finalGrade.grade"
                                        class="subject-grade final-grade"
                                        fxLayoutAlign="center center"
                                        [style.background]="finalGrade.grade.passing ? '#71B340' : '#FF0000'"
                                    >
                                        <span>{{ finalGrade.grade ? finalGrade.grade.numericValue : '-' }}</span>
                                    </div>
                                </div>
                            </mat-list-item>
                        </div>
                        <div *ngIf="partialGrades?.length">
                            <mat-list-item class="subject-container mb-12" *ngFor="let partialGrade of partialGrades">
                                <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="column" fxLayoutAlign="start">
                                        <span class="subject-title">{{ partialGrade.gradedUnit.name }}</span>
                                        <span class="subject-description"
                                            >{{ partialGrade.grade ? partialGrade.grade.displayValue : ('GRADES.LABEL.STATUS.NOT_ASSESSED' | translate) }}
                                        </span>
                                    </div>
                                    <div class="subject-grade" fxLayoutAlign="center center" *ngIf="partialGrade.grade">
                                        <span>{{ partialGrade.grade.numericValue }}</span>
                                    </div>
                                </div>
                            </mat-list-item>
                        </div>
                    </mat-list>
                </div>
                <!-- / CONTENT -->
            </div>

            <!-- Attendances -->
            <div class="content-card mat-elevation-z2 white user-data" *ngIf="isModuleFeatureAttendanceActive">
                <mat-toolbar-row class="form-toolbar parent" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="toolbar-title">
                            <span>{{ 'EVENT.ATTENDANCE.EVENT_ATTENDANCE' | translate }}</span
                            >&nbsp;
                            <span *ngIf="moduleUser">({{ moduleUser.attendance?.percentage }}%)</span>
                        </span>
                    </div>
                    <button class="custom-white-button" (click)="openManageParticipantAttendancesDialog()">
                        <span class="strong">{{ 'GENERAL.BUTTON.MANAGE' | translate }}</span>
                    </button>
                </mat-toolbar-row>

                <div class="content p-24" fxLayout="column">
                    <div *ngIf="participantAttendances.length; else noAttendances">
                        <mat-list fxLayout="row wrap" fxLayout.xs="column wrap">
                            <h3 class="mt-0 events-label">{{ 'EVENT.PLURAL' | translate }}</h3>
                            <mat-list-item class="manage-attendances-list-container mb-12 mr-8 w-50" *ngFor="let participantAttendance of participantAttendances">
                                <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutAlign="space-between center" class="manage-attendances-list-item w-100-p">
                                        <div class="w-100-p" fxLayout="column" fxLayoutAlign="start">
                                            <span class="title">{{ participantAttendance.event.name }}</span>
                                            <div class="date mt-4">
                                                <span>{{ participantAttendance.event.start | date: 'medium' }} - {{ participantAttendance.event.end | date: 'medium' }}</span>
                                                <span *ngIf="participantAttendance.event.location">
                                                    {{ 'GENERAL.LABEL.IN' | translate }} {{ participantAttendance.event.location.name }}
                                                </span>
                                            </div>
                                            <div fxLayout="column" class="mt-20">
                                                <div>
                                                    <span class="key">{{ 'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE' | translate }}: </span>
                                                    <span class="value">
                                                        {{
                                                            (participantAttendance.status === AttendanceStatus.UNMARKED
                                                                ? 'EVENT.ATTENDANCE.STATUS.UNMARKED'
                                                                : (participantAttendance.status | getStatusByValue: attendanceStatuses:'translationLabel')
                                                            ) | translate
                                                        }}
                                                    </span>
                                                </div>
                                                <div *ngIf="participantAttendance.comment">
                                                    <span class="key">{{ 'FORM.EVENT.FIELD.DESCRIPTION' | translate }}: </span>
                                                    <span class="value">{{ participantAttendance.comment }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <ng-template #noAttendances>
                        <div class="p-24 white no-assigned-certificates-container" fxLayout="column" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon class="mb-8">description</mat-icon>
                                <span>{{ 'EVENT.ATTENDANCE.NO_EVENTS_ATTENDED' | translate }}</span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <!-- Certificates -->
            <div class="content-card mat-elevation-z2 white user-data">
                <mat-toolbar-row class="form-toolbar parent" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="toolbar-title">
                            <span>{{ 'PAGE.USER_FORM.TAB.CERTIFICATES.TITLE' | translate }}</span>
                        </span>
                    </div>
                    <app-flat-button
                        [label]="'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.BUTTON.GIVE_CERTIFICATE'"
                        (onClick)="openDialogToGiveCertificate()"
                        [disabled]="!moduleCertificates?.length"
                    ></app-flat-button>
                </mat-toolbar-row>

                <div class="content p-24" fxLayout="column">
                    <div *ngIf="moduleUser?.certificates?.length; else noAssignedCertificates">
                        <mat-list fxLayout="row wrap" fxLayout.xs="column wrap">
                            <mat-list-item class="manage-certificate-list-container mb-12 mr-8" *ngFor="let moduleCertificate of moduleUser.certificates">
                                <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutAlign="space-between center" class="manage-certificate-list-content-container w-100-p">
                                        <div class="manage-certificate-list-content-image mr-12 pointer"></div>
                                        <div class="w-100-p" fxLayout="column" fxLayoutAlign="start">
                                            <span class="manage-certificate-list-title">{{ moduleCertificate.name }}</span>
                                            <span class="manage-certificate-list-file-name">{{ moduleCertificate.filename }}</span>
                                        </div>
                                    </div>
                                    <div fxFlex="row" fxLayoutAlign="end center">
                                        <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                                            <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                                        </button>

                                        <mat-menu #moreMenu="matMenu" xPosition="before">
                                            <button mat-menu-item aria-label="download" (click)="downloadModuleCertificate(moduleCertificate)">
                                                <span>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.BUTTON.DOWNLOAD_PDF' | translate }}</span>
                                            </button>

                                            <button mat-menu-item aria-label="remove" (click)="openDialogToRemoveCertificate(moduleCertificate)">
                                                <span>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.BUTTON.REMOVE_CERTIFICATE' | translate }}</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <ng-template #noAssignedCertificates>
                        <div class="p-24 white no-assigned-certificates-container" fxLayout="column" fxLayoutAlign="center center">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon class="mb-8">description</mat-icon>
                                <span>{{ 'CERTIFICATE.LABEL.NOT_ASSIGNED' | translate }}</span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap="8px grid">
            <div class="shimmer w-100-p mb-24">
                <div fxLayout="row wrap" fxLayoutGap="8px">
                    <div class="shimmer-card module animate !h-72" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(100%-8px)"></div>
                </div>
            </div>
            <div class="shimmer w-100-p">
                <div fxLayout="row wrap" fxLayoutGap="8px">
                    <div
                        *ngFor="let _ of [1, 2]; let i = index"
                        class="shimmer-card module animate mb-8 !h-60"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                    ></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
